import React from 'react';
import styles from './WatchlistActions.css';

import Cross from '../../images/cross-icon.svg';
import {
    WATCHLIST_DELETE,
    WATCHLIST_RENAME
} from '../../utils/watchlist-settings';
import WatchlistExportButton from './WatchlistExportButton';

const WatchlistActions = ({
    dispatchModal = () => {},
    isMobile = false,
    toggleActionDropdown = () => {}
}) => {
    const dispatchAndClose = (MODAL_NAME) => {
        dispatchModal(MODAL_NAME);
        toggleActionDropdown(false);
    };
    return (
        <div className="actions-container">
            {isMobile && (
                <div className="modal-header">
                    <h3 className="modal-title">Actions</h3>
                    <input
                        alt="close"
                        className="close-icon"
                        onClick={() => dispatchModal(false)}
                        onKeyPress={() => dispatchModal(false)}
                        src={Cross}
                        type="image"
                    />
                </div>
            )}
            <WatchlistExportButton
                toggleActionDropdown={toggleActionDropdown}
            />
            <button
                type="button"
                onClick={() => {
                    dispatchAndClose(WATCHLIST_RENAME);
                }}
                onKeyPress={() => {
                    dispatchAndClose(WATCHLIST_RENAME);
                }}
                className="rename-btn"
                data-metrics-type="DD"
            >
                Rename
            </button>
            <button
                type="button"
                onClick={() => {
                    dispatchAndClose(WATCHLIST_DELETE);
                }}
                onKeyPress={() => {
                    dispatchAndClose(WATCHLIST_DELETE);
                }}
                className="delete-btn"
                data-metrics-type="DD"
            >
                Delete
            </button>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistActions;
